import { afterSaleCount,requirementCount } from '@/api/countNum'
const countData = {
  state: {
    afterSaleNum: 0,
    requireNum:0
  },
  mutations: {
    SET_AFTER_SALE_COUNT (state, countNum) {
      state.afterSaleNum = countNum
    },
    SET_REQUIRE_COUNT (state, countNum) {
      state.requireNum = countNum
    }
  },
  actions: {
    updateAfterSaleCount({commit},param = {}) {
      afterSaleCount(param).then(({data}) => {
        commit('SET_AFTER_SALE_COUNT', data)
      })
    },
    updateRequireNumCount({commit},param = {}) {
      requirementCount(param).then(({data}) => {
        commit('SET_REQUIRE_COUNT', data)
      })
    }
  }
}

export default countData



// WEBPACK FOOTER //
// ./src/store/modules/countData.js